import React from 'react'
import Button from '@Components/Buttons/Button'

interface UploadedDocumentsFormButtonsProps {
    onUploadClicked: () => void
    onResetClicked: () => void
    onDoneClicked: () => void
    filesWereUploaded: boolean
    filesAreStaged: boolean
    isUploading: boolean
}

const UploadedDocumentsFormButtons = ({
    onUploadClicked,
    onDoneClicked,
    onResetClicked,
    filesWereUploaded,
    filesAreStaged,
    isUploading,
}: UploadedDocumentsFormButtonsProps) => (
    <>
        {!filesWereUploaded ? (
            <Button
                disabled={!filesAreStaged || isUploading}
                className="upload-files-button"
                mainColor
                type="primary"
                onClick={onUploadClicked}
            >
                Upload
            </Button>
        ) : (
            <Button className="upload-files-button" mainColor type="primary" onClick={onResetClicked}>
                Upload More
            </Button>
        )}
        {filesWereUploaded && (
            <Button className="done-button" mainColor type="primary" onClick={onDoneClicked}>
                Done
            </Button>
        )}
    </>
)

export default UploadedDocumentsFormButtons
